module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "orgchart-body node",
    attrs: {
      "draggable": "true"
    },
    on: {
      "mouseenter": function($event) {
        $event.preventDefault();
        _vm.activeChevron(true, _vm.data, _vm.rootNode)
      },
      "mouseleave": function($event) {
        $event.preventDefault();
        _vm.activeChevron(false, _vm.data, _vm.rootNode)
      }
    }
  }, [(_vm.data.imgsupvipath !== '') ? _c('div', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": 'data:image/jpeg;base64,' + _vm.data.imgsupvipath
    }
  })]) : _c('div', [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("static/images/employee/no_image.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "name color-skin"
  }, [_vm._v(_vm._s(_vm.data.desc_supvi))]), _vm._v(" "), _c('a', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.receivedOrgBodyDetail(_vm.data)
      }
    }
  }, [_c('div', {
    staticClass: "company"
  }, [_vm._v(_vm._s(_vm.data.desc_codcomp))]), _vm._v(" "), _c('div', {
    staticClass: "position"
  }, [_vm._v(_vm._s(_vm.data.desc_codpos))])]), _vm._v(" "), _c('div', [_c('i', {
    class: 'edge horizontalEdge leftEdge fa ' + _vm.classLeftEdge,
    on: {
      "click": function($event) {
        _vm.toggleSiblingNode()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('i', {
    class: 'edge horizontalEdge rightEdge fa ' + _vm.classRightEdge,
    on: {
      "click": function($event) {
        _vm.toggleSiblingNode()
      }
    }
  })]), _vm._v(" "), _c('div', [_c('i', {
    class: 'edge verticalEdge bottomEdge fa ' + _vm.classBottomEdge,
    on: {
      "click": function($event) {
        _vm.toggleBottomNode()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "cover-assist-icon"
  }, [(_vm.data.codassis !== '' && !_vm.data.assistActive) ? _c('i', {
    staticClass: "assist-icon fa fa-plus-circle cursor-pointer",
    on: {
      "click": function($event) {
        _vm.setActiveAssistNode(true)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.codassis !== '' && _vm.data.assistActive) ? _c('i', {
    staticClass: "assist-icon fa fa-minus-circle cursor-pointer",
    on: {
      "click": function($event) {
        _vm.setActiveAssistNode(false)
      }
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9cfbe8ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/orgchart/orgchartBody.vue
// module id = 3938
// module chunks = 1